<img class="table-images" src="{{src}}" (click)="clickHandler()"/>
